module.exports = __webpack_public_path__ + "img/1533742845.91632998.jpg";